// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d52ebb0f","455":"c38d0ba4","488":"988f21e3","977":"0c4abf58"}[chunkId] + ".chunk.js";
};